let audioCtx: AudioContext | null = null;
let osc: OscillatorNode | null = null;
let gain: GainNode | null = null;
let intervalId: number | null = null;

function ensureCtx() {
  if (!audioCtx) {
    audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
  }
  return audioCtx;
}

export function startRinging() {
  stopRinging();
  const ctx = ensureCtx();
  void ctx.resume?.();

  gain = ctx.createGain();
  gain.gain.value = 0.0001;
  gain.connect(ctx.destination);

  osc = ctx.createOscillator();
  osc.type = 'sine';
  osc.frequency.value = 880;
  osc.connect(gain);
  osc.start();

  // Simple pulse: beep every ~800ms
  intervalId = window.setInterval(() => {
    if (!gain) return;
    const now = ctx.currentTime;
    gain.gain.cancelScheduledValues(now);
    gain.gain.setValueAtTime(0.0001, now);
    gain.gain.linearRampToValueAtTime(0.12, now + 0.02);
    gain.gain.linearRampToValueAtTime(0.0001, now + 0.22);
  }, 800);
}

/** Short double-beep for urgent notification refresh (non-handoff). */
export function playUrgentChime() {
  const ctx = ensureCtx();
  void ctx.resume?.();
  const g = ctx.createGain();
  g.gain.value = 0.0001;
  g.connect(ctx.destination);
  const o = ctx.createOscillator();
  o.type = 'sine';
  o.frequency.value = 740;
  o.connect(g);
  o.start();
  const now = ctx.currentTime;
  g.gain.setValueAtTime(0.0001, now);
  g.gain.linearRampToValueAtTime(0.1, now + 0.02);
  g.gain.linearRampToValueAtTime(0.0001, now + 0.15);
  g.gain.linearRampToValueAtTime(0.1, now + 0.22);
  g.gain.linearRampToValueAtTime(0.0001, now + 0.38);
  o.stop(now + 0.42);
  window.setTimeout(() => {
    try {
      o.disconnect();
      g.disconnect();
    } catch {
      /* ignore */
    }
  }, 500);
}

export function stopRinging() {
  if (intervalId != null) {
    window.clearInterval(intervalId);
    intervalId = null;
  }
  try {
    osc?.stop();
  } catch {
    // ignore
  }
  try {
    osc?.disconnect();
    gain?.disconnect();
  } catch {
    // ignore
  }
  osc = null;
  gain = null;
}

